const infoItems = [
  {
    icon: 'ri-phone-fill',
    label: 'Telefon',
    primary: '02102 7398070',
    secondary: 'Mo–Fr 10:00–15:00 Uhr, Sa 12:00–15:00 Uhr',
    href: 'tel:+4921027398070',
  },
  {
    icon: 'ri-mail-fill',
    label: 'E-Mail',
    primary: 'kontakt@igmfacilityservice.de',
    secondary: 'Wir antworten innerhalb von 24 Stunden',
    href: 'mailto:kontakt@igmfacilityservice.de',
  },
  {
    icon: 'ri-map-pin-2-fill',
    label: 'Büro & Werkstatt',
    primary: 'Industriestr. 37',
    secondary: '40878 Ratingen, NRW',
    href: 'https://maps.google.com/?q=Industriestr.+37,+40878+Ratingen',
  },
  {
    icon: 'ri-time-fill',
    label: 'Bürozeiten',
    primary: 'Mo – Fr: 10:00 – 15:00 Uhr',
    secondary: 'Sa: 12:00 – 15:00 Uhr | So: geschlossen',
    href: null,
  },
];

const trustPoints = [
  'Gegründet 2021 — Erfahrenes Gründerteam',
  '3 Leistungssparten aus einer Hand',
  'Fachbetrieb mit qualifizierten Handwerksmeistern',
  'Festpreisgarantie – keine versteckten Kosten',
  'Tätig in ganz Rhein-Ruhr & NRW-weit',
];

export default function KontaktInfo() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">So erreichen Sie uns</h2>
        <p className="text-gray-500 text-sm leading-relaxed">
          Unser Team steht Ihnen für alle Fragen rund um Ihr Projekt zur Verfügung.
          Wir freuen uns auf Ihre Anfrage!
        </p>
      </div>

      {/* Ansprechpartner */}
      <div className="flex items-center gap-4 p-4 bg-[#0D2B4E]/5 rounded-xl border border-[#0D2B4E]/10">
        <img
          src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/8af539e3f70f99ed0ee7523e7c61a4aa.jpeg"
          alt="Ilker Sahin – Geschäftsführer IGM Facility Service"
          className="w-14 h-14 rounded-full object-cover object-top flex-shrink-0"
        />
        <div className="min-w-0">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Ihr Ansprechpartner</p>
          <p className="font-bold text-gray-900 text-sm">Ilker Sahin</p>
          <p className="text-xs text-gray-500">Geschäftsführer & Gründer</p>
          <a
            href="tel:+4921027398070"
            className="inline-flex items-center gap-1 text-xs text-[#0D2B4E] font-semibold mt-1 hover:underline"
          >
            <i className="ri-phone-line" />
            02102 7398070
          </a>
        </div>
      </div>

      {/* Info Items */}
      <div className="space-y-3">
        {infoItems.map((item) => (
          <div
            key={item.label}
            className="flex items-start gap-4 p-4 bg-white rounded-xl border border-gray-100 hover:border-[#0D2B4E]/20 transition-colors"
          >
            <div className="w-11 h-11 bg-[#0D2B4E] rounded-lg flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-lg text-white`} />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">{item.label}</p>
              {item.href ? (
                <a
                  href={item.href}
                  className="font-semibold text-gray-900 hover:text-[#0D2B4E] transition-colors block text-sm break-all"
                  {...(item.href.startsWith('http') ? { target: '_blank', rel: 'nofollow noopener noreferrer' } : {})}
                >
                  {item.primary}
                </a>
              ) : (
                <p className="font-semibold text-gray-900 text-sm">{item.primary}</p>
              )}
              <p className="text-xs text-gray-500 mt-0.5">{item.secondary}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Trust Badges */}
      <div className="bg-[#0D2B4E]/5 rounded-xl p-5 border border-[#0D2B4E]/10">
        <p className="text-sm font-semibold text-[#0D2B4E] mb-3">Warum IGM Facility Service wählen?</p>
        <div className="space-y-2">
          {trustPoints.map((item) => (
            <div key={item} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-[#C8A96E] text-sm font-bold" />
              </div>
              <span className="text-xs text-gray-700">{item}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Map */}
      <div className="rounded-xl overflow-hidden border border-gray-200" style={{ height: '220px' }}>
        <iframe
          title="IGM Facility Service Standort"
          src="https://maps.google.com/maps?q=Industriestr.+37,+40878+Ratingen,+Deutschland&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
